// =============================================================================
//  Copyright   : 2018 semantics GmbH
//  Date        : $Date: 2025-09-21 19:16:35 +0200 (Sun, 21 Sep 2025) $
//  Author      : Dirk Rothe
//  Worker      : $Author: d.rothe $
//  Revision    : $Rev: 156393 $
//  Purpose     : call wiki apis
// =============================================================================
// ---Third-party imports
import {put, takeEvery, select} from 'redux-saga/effects'

// ---Framework imports
import log from 'uix/logging'
import {dismissNotification} from './actions'
import {delay} from 'uix/sagas'
import {isSSR} from 'uix/utils'

// ---Globals
function* _showNotification({payload}) {
  let {dismissAfter, id} = payload

  if (process.env.NODE_ENV !== 'production' && isSSR) {
    log.saga(`${payload.type} notification`)
    log[payload.type == 'ERROR' ? 'error' : 'info'](payload)
  }

  if (dismissAfter) {
    yield delay(dismissAfter)
    let isVisible = select(root => root.data.notify.some(e => e.id === id))
    if (isVisible) {
      yield put(dismissNotification(id))
    }
  }
}

export const sagas = {
  showNotification: takeEvery('NOTIFICATION_SHOW', _showNotification),
  warnNotification: takeEvery('NOTIFICATION_WARN', _showNotification),
  succNotification: takeEvery('NOTIFICATION_SUCCESS', _showNotification),
  errorNotification: takeEvery('NOTIFICATION_ERROR', _showNotification),
}
